export const MSG_NO_INTERSECTION_OBSERVER_API = `
This browser has no (full) support for the IntersectionObserver API,
 inject the official polyfill or enable maiaAllowMissingIntersectionObserver
 for disabling it on unsupported browsers.`;
